import { lazy } from "react";
import AuthGuard from "routes/AuthGuard";
import Loadable from "routes/Loadable";
import AdminLayout from "components/layouts/adminLayout";

//investment
const InvestmentList = Loadable(lazy(() => import("pages/investment")));
const InvestmentReturn = Loadable(lazy(() => import("pages/investment/InvestmentReturn")));
const InvestmentReturnRecords = Loadable(lazy(() => import("pages/investment/InvestmentReturnRecords")));

// re investment
const ReInvestment = Loadable(lazy(() => import("pages/investment/Reinvestment")));

const InvestmentRoutes = {
  path: "investment",
  element: (
    <AuthGuard>
      <AdminLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "list",
      element: <InvestmentList />,
    },
    {
      path: "re-investment/:investmentId",
      element: <ReInvestment />,
    },
    {
      path: "details/:investmentId",
      element: <InvestmentReturn />,
    },
    {
      path: "return-records",
      element: <InvestmentReturnRecords />,
    },
  ],
};

export default InvestmentRoutes;
